<script setup lang="ts">
import AdressenGrid from '@/components/adressen-grid.vue'
import KpToolbar from '@/components/kp-toolbar.vue'
import { useRouter } from 'vue-router'
import { useRoute } from 'vuetify/lib/composables/router.mjs'

const router = useRouter()
const route = useRoute()

function onAdd() {
    router.push({ name: 'adresse', params: { id: 'new' } })
}
</script>

<template>
    <div v-if="route?.name === 'adressen'">
        <KpToolbar :title="$t('adressen')" icon="far fa-address-book">
            <template #controls>
                <v-btn
                    class="hidden-xs"
                    rounded="xl"
                    variant="flat"
                    color="subtleHint"
                    @click="onAdd"
                    prepend-icon="fas fa-plus"
                >
                    {{ $t('new_address') }}
                </v-btn>
                <v-btn
                    class="hidden-sm-and-up"
                    rounded="xl"
                    variant="flat"
                    color="subtleHint"
                    @click="onAdd"
                    icon="fas fa-plus"
                >
                </v-btn>
            </template>
        </KpToolbar>
        <v-container fluid class="kp-large-container">
            <AdressenGrid
                :headerwidths="{
                    typ: '55px',
                    name: '15%',
                    vorname: '20%',
                    adresse: '30%',
                    land: '10%',
                    plz: '10%',
                    ort: '15%',
                    action: '110px',
                }"
            ></AdressenGrid>
        </v-container>
    </div>
    <router-view v-else />
</template>

<style lang="scss" scoped>
.small-icon {
    font-size: 15px;
}
</style>
